var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/eye-off",
    clipPath: "url(#clip0_679_24814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.58666 6.58667C6.39016 6.76977 6.23256 6.99057 6.12324 7.2359C6.01393 7.48123 5.95515 7.74607 5.95042 8.01461C5.94568 8.28315 5.99508 8.54989 6.09567 8.79893C6.19625 9.04797 6.34597 9.27419 6.53589 9.46411C6.72581 9.65402 6.95203 9.80374 7.20107 9.90433C7.4501 10.0049 7.71685 10.0543 7.98539 10.0496C8.25393 10.0448 8.51876 9.98606 8.76409 9.87675C9.00943 9.76744 9.23023 9.60983 9.41333 9.41334",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.15332 3.38667C7.43419 3.35168 7.71694 3.33386 7.99999 3.33334C12.6667 3.33334 14.6667 8 14.6667 8C14.3686 8.63808 13.9948 9.23796 13.5533 9.78667",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.40668 4.40667C3.08084 5.30975 2.01992 6.55018 1.33334 8C1.33334 8 3.33334 12.6667 8.00001 12.6667C9.27728 12.6701 10.5272 12.2967 11.5933 11.5933",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.33334 1.33334L14.6667 14.6667",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_679_24814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.2c0c9e88a524326667bd803cd3e02ac7.svg";
export { ForwardRef as ReactComponent };